query GetActivitySyncStatus($activityId: ID!) {
    activity(id: $activityId) {
        id
        isConnectedToExternalCalendar
    }
}
